import {inject, Injectable} from '@angular/core';
import {NullablePrimitive, Stdlib} from '../lib/stdlib';
import {KeyValueApi, type SegmentParameter, SegmentParameterApi} from '../../api-client-kt/src';

@Injectable({
    providedIn: 'root'
})
export class KeyValueAndParamsService {

    private readonly keyValueApi = inject(KeyValueApi);
    private readonly segmentParameterApi = inject(SegmentParameterApi);

    constructor() {
    }

    async createDataRecord(data: any): Promise<string> {
        const result = await this.keyValueApi.create({ createKeyValueRequest: { value: data } });
        return result.id;
    }

    async loadDataRecord(recordId: string): Promise<any> {
        const result = await this.keyValueApi.get({ id: recordId });
        return result;
    }

    async getSegmentParams(segmentId: string): Promise<Record<string, NullablePrimitive>> {
        const parameter = await this.segmentParameterApi.getAllParameters({ id: segmentId });
        return Object.fromEntries(parameter.map(p => [p.name, p.value]));
    }

    async storeSegmentParams(segmentId: string, params: Record<string, NullablePrimitive>) {
        const parameterList = Object.entries(params)
            .map(([name, value]) => ({ name, value: value ?? null }))

        // we only support nullable number parameters for now
        const segmentParameter = parameterList
            .filter(it => Stdlib.isNumberOrNull(it.value)) as SegmentParameter[];

        if (segmentParameter.length !== parameterList.length) {
            throw new Error('Only nullable number parameters are supported');
        }

        await this.segmentParameterApi.updateParameters({ id: segmentId, segmentParameter });
    }
}
